module.exports = __webpack_public_path__ + "static/img/pay-fr-btn.be44f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-fr-btn.png
// module id = Aa2j
// module chunks = 1